import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { useToastClearance } from "@/lib/toast-clearance";
import { router } from "@/routes/router";

/**
 * Les toasts se posent au-dessus des barres collées en bas (navigation sur
 * téléphone, pied d'actions du recueil client) : `--toast-offset-bottom` est
 * tenu par `useToastClearance` ; sans barre, les décalages par défaut de
 * sonner (32 px, 16 px sur téléphone).
 */
const TOAST_OFFSET = { bottom: "var(--toast-offset-bottom, 32px)" };
const TOAST_MOBILE_OFFSET = { bottom: "var(--toast-offset-bottom, 16px)" };

export default function App() {
  useToastClearance();
  return (
    <>
      <RouterProvider router={router} />
      <Toaster
        position="bottom-right"
        richColors
        closeButton
        expand
        offset={TOAST_OFFSET}
        mobileOffset={TOAST_MOBILE_OFFSET}
      />
    </>
  );
}
